import axios from 'axios';
import { silentParam } from '../api';
import {
  BucketBy, CleanupResponse, HeatmapResponse, KpiResponse, LeadtimeResponse, PharmaciesResponse, ProductCardResponse, ProductsResponse, TimelineResponse
} from './analyticsTypes';

/** Аналитика документов: через основной бэкенд (/api/v2/documents/analytics → :3003) */
const BASE = '/api/v2/documents/analytics';

type Params = Record<string, string>;

async function get<T>(path: string, params: Params, silent: boolean, signal?: AbortSignal): Promise<T> {
  const res = await axios.get(`${BASE}/${path}`, { params: { ...params, ...silentParam(silent) }, signal });
  return res.data;
}

/**
 * Просмотр аналитики пишется в журнал действий только запросом показателей (kpi без silent);
 * графики и таблицы вкладки всегда идут с silent - открытие вкладки или смена фильтров дают одну запись.
 * Исключение - карточка товара: её открытие пишется отдельной записью с названием товара.
 */
export const analyticsApi = {
  kpi: (params: Params, silent: boolean, signal?: AbortSignal) => get<KpiResponse>('kpi', params, silent, signal),
  timeline: (params: Params, by: BucketBy, signal?: AbortSignal) => get<TimelineResponse>('timeline', { ...params, by }, true, signal),
  leadtime: (params: Params, signal?: AbortSignal) => get<LeadtimeResponse>('leadtime', params, true, signal),
  pharmacies: (params: Params, signal?: AbortSignal) => get<PharmaciesResponse>('pharmacies', params, true, signal),
  heatmap: (params: Params, signal?: AbortSignal) => get<HeatmapResponse>('heatmap', params, true, signal),
  cleanup: (params: Params, by: BucketBy, signal?: AbortSignal) => get<CleanupResponse>('cleanup', { ...params, by }, true, signal),
  /** Обзор товаров: фильтры аналитики + срезы (producer, ptype, rxotc, folder, mnn) и поиск q */
  products: (params: Params, signal?: AbortSignal) => get<ProductsResponse>('products', params, true, signal),
  product: (id: string, params: Params, by: BucketBy, silent: boolean, signal?: AbortSignal) =>
    get<ProductCardResponse>(`products/${encodeURIComponent(id)}`, { ...params, by }, silent, signal)
};
